import { useEffect } from 'react';
import { useAccounts } from '@features/trades/hooks/useTradeMetadata';
import { useAccount, useSetAccount } from './accountStore';

/**
 * Auto-picks the first account whenever the global account is empty (or no longer matches a
 * known account — e.g. the user wiped all trades for the previously-selected account, or
 * switched between dev environments). Mirrors the old Blazor `AccountModel = Accounts.First()`
 * behaviour at <SessionFilterComponent>.OnInitializedAsync().
 *
 * Renders nothing. Mount once near the top of the tree so every route sees a sane account
 * before its first render.
 */
export function AccountInitializer() {
  const accounts   = useAccounts();
  const account    = useAccount();
  const setAccount = useSetAccount();

  useEffect(() => {
    if (!accounts.data || accounts.data.length === 0) return;
    if (account && accounts.data.some(a => a.name === account)) return;
    setAccount(accounts.data[0]?.name ?? '');
  }, [accounts.data, account, setAccount]);

  return null;
}
